<div class="container ">
  <div class="tw-bg-pinkDark text-center tw-py-8 md:tw-p-8 tw-rounded-xl">
    <div class="tw-relative">
      <img alt="FAQ" src="../assets/images/landing-page/question.svg"
        class="tw-w-12 md:tw-w-28 lg:tw-w-32 tw-object-cover tw-absolute tw-left-0 tw-top-10 md:tw-top-2 lg:tw-top-1">
    </div>

    <div class="tw-text-base md:tw-text-xl lg:tw-text-3xl tw-font-extrabold tw-text-white md:tw-py-4 tw-pb-3">
      Still have a question?
      <br>
    </div>
    <div class="d-flex justify-content-center tw-text-xs md:tw-text-lg tw-gap-4 md:tw-gap-6 tw-pl-8">
      <button class="tw-bg-white tw-text-pinkDark tw-border tw-border-pinkDark tw-rounded tw-px-2 md:tw-px-8 tw-p-1 
        hover:tw-bg-pinkDark hover:tw-text-white hover:tw-border-white tw-font-bold" (click)="navigate()">Talk to an
        expert</button>
      <a class="tw-text-white tw-font-bold hover:tw-text-white hover:tw-text-[#F7B703] tw-underline tw-pt-2"
        aria-label="Email PumPumPum" href="mailto:corporate@pumpumpum.com">{{emailId}}</a>
    </div>
  </div>
</div>